import { Form, type FormProps } from "@hopper-ui/components";
import { forwardRef, type ReactNode } from "react";
import { InnerPage } from "./InnerPage.tsx";

interface Props extends Omit<FormProps, "content"> {
    content?: ReactNode;
    footer?: ReactNode;
}

export const FormPage = forwardRef<HTMLFormElement, Props>(({ children, content, footer, ...rest }, ref) => {
    return (
        <Form
            ref={ref}
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="center"
            overflow="hidden"
            width="100%"
            {...rest}
        >
            <InnerPage content={content} footer={footer} />
        </Form>
    );
});
